import { gql } from '@apollo/client'

export default gql(`
query listViewHistory( $userId: ID! ) {
    listViewHistory( 
        userId: $userId
    ) {
        assetId{
            id
            title
        }
        progress{
            position
            updatedAt
        }
    }
}`)
